import { ClientVideoUpload } from "../inputs/ClientVideoUpload";
import { SharedFilePreview } from "./SharedFilePreview";
export const VideoPreview = props => {
  return <SharedFilePreview fileType="Video" renderCapturedText={() => 'Video Captured'} UploadComponent={ClientVideoUpload} {...props} />;
};